import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyStateCardBody } from '../../components/EmptyStateCard';

export const EmptyCertificates: React.FC = () => {
  const { t } = useTranslation();
  return <EmptyStateCardBody title={t('certificates.table.empty')} />;
};
